export default {
  modalTitle: {
    id: 'listings_listings_actions',
    defaultMessage: 'Listings actions',
  },
  exportListings: {
    id: 'listings_export_modal_title',
    defaultMessage: 'Export listings',
  },
  exportListingsInCsv: {
    id: 'listings_export_listings_in_csv',
    defaultMessage: 'Export existing listings in CSV',
  },
  importListings: {
    id: 'listings_import_modal_title',
    defaultMessage: 'Create listing of existing items',
  },
  importListingsThroughCsv: {
    id: 'listings_import_listings_through_csv',
    defaultMessage: 'Import new listings through CSV',
  },
  importNewProductListings: {
    id: 'listings_import_new_product_modal_title',
    defaultMessage: 'Create listing of existing items',
  },
  importNewProductListingsThroughCsv: {
    id: 'listings_import__new_product_listings_through_csv',
    defaultMessage: 'Create listings of new items',
  },
  updateListings: {
    id: 'listings_update_modal_title',
    defaultMessage: 'Update listings',
  },
  updateExistingListingsPricesAndStock: {
    id: 'listings_update_existing_listings_prices_stock',
    defaultMessage: 'Update prices and stock of existing listings',
  },
  // Toast
  toastActionsErrorTitle: {
    id: 'listings_actions_modal_toast_error_title',
    defaultMessage: 'Oops, something went wrong.',
  },
  toastExportSuccessTitle: {
    id: 'listings_export_modal_toast_success_title',
    defaultMessage: 'Export successful',
  },
  toastExportSuccessText: {
    id: 'listings_export_modal_toast_success_text',
    defaultMessage: 'Your export has been created. Please check your emails.',
  },
  toastExportErrorText: {
    id: 'listings_export_modal_toast_error_text',
    defaultMessage: 'Your export failed. Please try again.',
  },
  toastImportErrorText: {
    id: 'listings_import_modal_toast_error_text',
    defaultMessage: 'Your import failed. Please try again.',
  },
  toastImportSuccessTitle: {
    id: 'listings_import_modal_toast_success_title',
    defaultMessage: 'Import successful',
  },
  toastImportSuccessText: {
    id: 'listings_import_modal_toast_success_text',
    defaultMessage: 'Your import has been created. Please check your emails.',
  },
  toastUpdateErrorText: {
    id: 'listings_update_toast_error_text',
    defaultMessage: 'Your update failed. Please try again.',
  },
  toastUpdateSuccessTitle: {
    id: 'listings_update_toast_success_title',
    defaultMessage: 'Update successful',
  },
  toastUpdateSuccessText: {
    id: 'listings_update_toast_success_text',
    defaultMessage: 'Your update has been created. Please check your emails.',
  },
  close: {
    id: 'listings_import_export_drawer_close',
    defaultMessage: 'Close',
  },
}
